import React, { ChangeEvent, useState } from 'react'
import { FormCheckboxField, FormErrorText, FormField } from '@/components/Form/FormField'
import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { ClientEmailDto } from 'api/Clients/Types/ClientDetailedDto'
import { EmailPattern } from 'utils/formValidation'

interface OuterProps {
  isOpen?: boolean
  onClose(): void
  data: ClientEmailDto
  emails: ClientEmailDto[]
  handleChange(values: ClientEmailDto): void
}

export const EmailModal: React.FC<OuterProps> = ({
  isOpen,
  onClose,
  handleChange,
  emails,
  data,
}) => {
  const [form, setForm] = useState<ClientEmailDto>({
    id: data.id,
    tempId: data.tempId,
    address: data.address,
    emailType: 'Personal',
    isPrimary: data.isPrimary,
    isUsedIn2FA: data.isUsedIn2FA,
  })
  const [error, setErrors] = useState<string>('')

  const validateForm = () => {
    if (!EmailPattern.test(form.address)) {
      setErrors('Not email type')
      return
    }
    if (!form.isPrimary && emails.find((x) => x.id !== form.id && !x.isPrimary)) {
      setErrors('You need select at least one primary Email.')
      return
    }
    if (
      emails.find(
        (e) =>
          e.address.trim().toLowerCase() === form.address.trim().toLowerCase() && e.id !== form.id
      )
    ) {
      setErrors('Email already exists.')
      return
    }

    handleChange(form)
  }

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{data.id ? 'Edit Email' : 'Add New Email'}</DialogTitle>
        </DialogHeader>
        <div className='flex flex-col gap-4'>
          <FormField
            label='Email Address *'
            value={form.address}
            onChange={(event: ChangeEvent<HTMLInputElement>) => {
              setErrors('')
              setForm({ ...form, address: event.target.value })
            }}
          />
          <FormCheckboxField
            label='Primary'
            value={form.isPrimary}
            onChange={(checked) => setForm({ ...form, isPrimary: checked })}
          />
          <FormErrorText message={error} />
        </div>
        <DialogFooter>
          <Button onClick={onClose} type='button' variant='outline'>
            Cancel
          </Button>
          <Button disabled={!form.address} type='button' onClick={validateForm}>
            {data.id ? 'Save' : 'Add'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
